import { useEffect } from 'react';

const DeskDone = () => {
    useEffect(() => {
        const timer = window.setTimeout(() => window.close(), 400);
        return () => window.clearTimeout(timer);
    }, []);

    return (
        <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
            <p>Signed in. This window closes, and HR stays in Desk.</p>
        </div>
    );
};

export default DeskDone;
